import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import PastRoleForm from '../../common/PastRolesQuestion/PastRoleForm';
import { date } from '../../../dateUtils';
import { analyticsTrack } from '../../../analyticsUtils';

const months = [
  { label: 'January', value: '0' },
  { label: 'February', value: '1' },
  { label: 'March', value: '2' },
  { label: 'April', value: '3' },
  { label: 'May', value: '4' },
  { label: 'June', value: '5' },
  { label: 'July', value: '6' },
  { label: 'August', value: '7' },
  { label: 'September', value: '8' },
  { label: 'October', value: '9' },
  { label: 'November', value: '10' },
  { label: 'December', value: '11' },
];

const editablePastRole = (pastRole) => {
  const pr = {
    title: pastRole.title,
    role: pastRole.role,
    companyName: pastRole.company_name,
    current: pastRole.current,
    is_suggested: pastRole.is_suggested,
    remove: false,
  };
  if (pastRole.start_date) {
    const startDateArray = pastRole.start_date.split('-').map((x) => Number(x));
    // Subtracted 1 to get the correct month
    const startDate = new Date(startDateArray[0], startDateArray[1] - 1, startDateArray[2]);
    pr.startDateMonth = months[startDate.getMonth()];
    const startYear = startDate.toLocaleString('default', { year: 'numeric' });
    pr.startDateYear = { label: startYear, value: startYear };
  }
  if (pastRole.end_date) {
    const endDateArray = pastRole.end_date.split('-').map((x) => Number(x));
    const endDate = new Date(endDateArray[0], endDateArray[1] - 1, endDateArray[2]);
    pr.endDateMonth = months[endDate.getMonth()];
    const endYear = endDate.toLocaleString('default', { year: 'numeric' });
    pr.endDateYear = { label: endYear, value: endYear };
  }
  return pr;
};

const submittablePastRole = (pastRole) => {
  let submittableStartDate = null;
  let submittableEndDate = null;
  if (pastRole.startDateMonth) {
    submittableStartDate = new Date(`${pastRole.startDateMonth.label} 1, ${pastRole.startDateYear.label}`).toISOString('default', { month: 'numeric', year: 'numeric' }).slice(0, 10);
  } else if (pastRole.startDateYear) {
    submittableStartDate = new Date(`${pastRole.startDateYear.label}`).toISOString('default', { month: 'numeric', year: 'numeric' }).slice(0, 10);
  }
  if (pastRole.endDateMonth) {
    submittableEndDate = new Date(`${pastRole.endDateMonth.label} 1, ${pastRole.endDateYear.label}`).toISOString('default', { month: 'numeric', year: 'numeric' }).slice(0, 10);
  } else if (pastRole.endDateYear) {
    submittableEndDate = new Date(`${pastRole.endDateYear.label}`).toISOString('default', { month: 'numeric', year: 'numeric' }).slice(0, 10);
  }
  const pr = {
    title: pastRole.title,
    role: pastRole.role,
    company_name: pastRole.companyName,
    start_date: submittableStartDate,
    end_date: submittableEndDate,
    current: pastRole.current,
    is_suggested: pastRole.is_suggested,
    is_edited: pastRole.is_edited || false,
    remove: pastRole.remove,
  };
  return pr;
};

class ClaimPastRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      showModal: false,
      pastRole: editablePastRole(props.pastRole),
      errors: [],
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleShowModal() {
    this.setState({ isHovering: false, showModal: true });
    analyticsTrack('Clicked Edit past role', {
      location: 'Onboarding Flow',
      specific_location: 'Claim Info',
    });
  }

  handleCloseModal() {
    this.setState({ isHovering: false, showModal: false });
  }

  handleInputChange(value, key) {
    const { pastRole } = this.state;
    pastRole[key] = value;
    pastRole.is_edited = true;
    this.setState({ pastRole });
  }

  handleDateChange(value, key) {
    const { pastRole } = this.state;
    pastRole[key] = value;
    pastRole.is_edited = true;
    this.setState({ pastRole });
  }

  handleValidation() {
    const { pastRole } = this.state;
    let error = [];
    if (!pastRole.title) { error.push('title'); }
    if (!pastRole.companyName) { error.push('company name'); }
    if (pastRole.startDateYear == null) {
      error.push('start date');
    }
    if (!pastRole.current) {
      if (pastRole.endDateYear == null) {
        error.push('end date');
      } else if (!error.includes('start date')) {
        const safeStartMonth = pastRole.startDateMonth ? pastRole.startDateMonth.value : null;
        const safeEndMonth = pastRole.endDateMonth ? pastRole.endDateMonth.value : null;
        const startDate = new Date(pastRole.startDateYear.value, safeStartMonth);
        const endDate = new Date(pastRole.endDateYear.value, safeEndMonth);
        if (startDate > endDate) {
          error = error.concat(['end date', 'The end date must be after the start date.']);
        }
      }
    }
    return error;
  }

  handleDelete() {
    const { pastRole } = this.state;
    const { handleUpdatePastRole, index } = this.props;
    pastRole.remove = !pastRole.remove;
    handleUpdatePastRole(submittablePastRole(pastRole), index);
    analyticsTrack(`Clicked ${pastRole.remove ? 'Delete' : 'Add'} past role`, {
      location: 'Onboarding Flow',
      specific_location: 'Claim Info',
    });
  }

  handleSubmit() {
    const errors = this.handleValidation();
    if (errors.filter((e) => e.length > 0).length === 0) {
      const { pastRole } = this.state;
      const { handleUpdatePastRole, index } = this.props;
      handleUpdatePastRole(submittablePastRole(pastRole), index);
      this.setState({ errors: [] });
      this.handleCloseModal();
    } else {
      this.setState({ errors });
    }
  }

  renderPastRoleForm() {
    const { pastRole, errors } = this.state;
    return (
      <form className="edit-past-role" onSubmit={(event) => event.preventDefault()}>
        <PastRoleForm
          classNamePrefix="profile-add-past-role"
          pastRole={pastRole}
          errors={errors}
          handleInputChange={this.handleInputChange}
          handleDateChange={this.handleDateChange}
        />
        <div className="center">
          <button
            className="btn btn-primary"
            onClick={() => this.handleSubmit()}
          >
            Save
          </button>
        </div>
      </form>
    );
  }

  render() {
    const { pastRole } = this.props;
    const { isHovering, showModal } = this.state;
    return (
      <div
        className="past-role g-row g-row--between"
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
      >
        <Modal
          dialogClassName="past-roles-modal"
          className="style-guide"
          show={showModal}
          onHide={this.handleCloseModal}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            {this.renderPastRoleForm()}
          </Modal.Body>
        </Modal>
        <div className={`g-flex-8 ${pastRole.remove && 'remove-past-role'}`}>
          <div className="fs-hide medium-weight">
            {pastRole.title}
          </div>
          <div className="fs-hide">
            {pastRole.role}
          </div>
          <div className="fs-hide">
            {pastRole.company_name}
          </div>
          <div className="mute fs-hide">
            {date(pastRole.start_date, pastRole.end_date, pastRole.current)}
          </div>
        </div>
        {isHovering
          && (
          <div className="g-flex-4">
            <button className="btn btn-small btn-secondary" onClick={this.handleShowModal}>
              Edit
            </button>
            <button
              className="btn btn-small btn-warning"
              onClick={this.handleDelete}
            >
              {pastRole.remove ? 'Add' : 'Delete'}
            </button>
          </div>
          )}
      </div>
    );
  }
}

ClaimPastRole.propTypes = {
  pastRole: PropTypes.shape({}).isRequired,
  handleUpdatePastRole: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default ClaimPastRole;
